import axios from 'axios'
import { SIDEBAR } from '../type'
import { getMockData } from '../../utils/api'
import { subProjectReportSchema } from '../../layouts/sidebarProposal/mock/subProjectSchema'
import { auditSchema } from '../../layouts/sidebarProposal/mock/auditSchema'
import { config, API_ROOT, API_TIMEOUT } from '../../config/config'
import { axiosInterceptors } from '../utils/httpClient'
import {
  authen,
  clearLocalStorage,
  isAuthenticated,
  refreshToken,
  setLocalStorage,
  setSession,
} from './auth'
import pathname from '../../constants/pathname'
import { evaluatesSchema } from '../../layouts/sidebarProposal/mock/evaluatesSchema'
import { newSubProjectSchema } from '../../layouts/sidebarProposal/mock/newSubProjectSchema'
import { handleError } from './utils'

export const getSchemaSidebar = (projectId) => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })

  const url = `${API_ROOT}/proposal/${projectId}/menu`

  return axios
    .get(url, API_TIMEOUT)
    .then((response) => {
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'sidebar', projectId)
    })
}

export const getSchemaMultiReviewSidebar = (projectId) => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })

  // let request
  let idList = sessionStorage.getItem('mutiReview')
  let request = {
    projectVersionIds: idList?.split(','),
    reviewGroupId: projectId,
  }

  console.log('request', request)
  // const url = `http://localhost:9002/api/proposal/multi-review/${projectId}/menu`
  const url = `${API_ROOT}/proposal/multi-review/${projectId}/menu`
  return axiosInterceptors
    .post(url, request, API_TIMEOUT)
    .then((response) => {
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'multiReview', projectId)
    })
}

export const getSchemaMultiAproveSidebar = (approveType, option) => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })

  // const url = `http://localhost:9002/api/proposal/multi-approve/menu/${approveType}?all=${
  //   option || 0
  // }`

  const url = `${API_ROOT}/proposal/multi-approve/menu/${approveType}?all=${option || 0}`

  return axiosInterceptors
    .get(url, API_TIMEOUT)
    .then((response) => {
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'multiAprove', approveType)
    })
}

export const getSchemaSubProjectSidebar = (projectId) => (dispatch) => {
  // console.log('oooooooo')
  dispatch({ type: SIDEBAR.REQUEST })

  const url = `${API_ROOT}/subproject/new-menu?projectVersionId=${projectId || ''}`
  // const url = `${API_ROOT}/subproject/${projectId}/menu`
  return axiosInterceptors
    .get(url, API_TIMEOUT)
    .then((response) => {
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'subProject', projectId)
    })
}

export const getSchemaSubProjectDep6Sidebar = (projectId) => (dispatch) => {
  // console.log('SIDEBAR.REQUEST => ', SIDEBAR.REQUEST)
  dispatch({ type: SIDEBAR.REQUEST })

  const url = `${API_ROOT}/subproject/new-menu?projectVersionId=${projectId || ''}`
  //const url = `${API_ROOT}/subproject/${projectId}/menu`
  return axiosInterceptors
    .get(url, API_TIMEOUT)
    .then((response) => {
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'subProjectDep6', projectId)
    })
}

export const getSchemaMultiApproveReviewerSidebar = (groupId) => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })

  const url = `${API_ROOT}/proposal/multi-approve-reviewer/${groupId}/menu`
  return axiosInterceptors
    .get(url, API_TIMEOUT)
    .then((response) => {
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'multiApproveReviewer', projectId)
    })
}

export const getSchemaLegalManagementSidebar = () => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })
  // const url = `http://localhost:9002/api/proposal/legal-management/menu`
  const url = `${API_ROOT}/proposal/legal-management/menu`
  return axios
    .get(url, API_TIMEOUT)
    .then((response) => {
      // console.log('response ', response)
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'legalManagement')
    })
}

export const getSchemaAssetCirculatingSidebar = () => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })
  // /api/proposal/asset-circulating/menu
  const url = `${API_ROOT}/proposal/asset-circulating/menu`
  return axios
    .get(url, API_TIMEOUT)
    .then((response) => {
      // console.log('response ', response)
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'legalManagement')
    })
}

export const getSchemaWithdrawReviewSidebar = () => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })
  // /api/proposal/withdraw-review/menu
  const url = `${API_ROOT}/proposal/withdraw-review/menu`
  return axios
    .get(url, API_TIMEOUT)
    .then((response) => {
      // console.log('response ', response)
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'withdrawReview')
    })
}

export const getSchemaReportManagementSidebar = () => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })
  // const url = `http://localhost:9002/api/proposal/legal-management/menu`
  const url = `${API_ROOT}/proposal/report-management/menu`
  return axios
    .get(url, API_TIMEOUT)
    .then((response) => {
      // console.log('menu response ', response)
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'reportManagement')
    })
}

export const getSchemaDataManagementSidebar = () => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })
  // const url = `http://localhost:9002/api/proposal/data-management/menu`
  const url = `${API_ROOT}/proposal/data-management/menu`
  return axios
    .get(url, API_TIMEOUT)
    .then((response) => {
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'dataManagement')
    })
}

export const getSchemaAccountingSidebar = () => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })
  // const url = `http://localhost:9002/api/proposal/accounting/menu`
  const url = `${API_ROOT}/proposal/accounting/menu`

  return axios
    .get(url, API_TIMEOUT)
    .then((response) => {
      // console.log('menu => ', JSON.stringify(response.data))

      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'accounting')
    })
}

export const getSchemaAccountingIncomExpenseSidebar = () => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })
  // const url = `http://localhost:9002/api/proposal/accounting/income-expense/menu`
  const url = `${API_ROOT}/proposal/accounting/income-expense/menu`
  return axios
    .get(url, API_TIMEOUT)
    .then((response) => {
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'accountingIE')
    })
}

export const getSchemaAuditExpenseSidebar = () => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })
  // http://103.91.191.229:9000/api/proposal/internal-audit/menu
  const url = `${API_ROOT}/proposal/internal-audit/menu`
  return axios
    .get(url, API_TIMEOUT)
    .then((response) => {
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'internalAudit')
    })
}

export const getSchemaAccountingApproverSidebar = () => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })
  // const url = `http://localhost:9002/api/proposal/accounting/approver/menu`
  const url = `${API_ROOT}/proposal/accounting/approver/menu`
  return axios
    .get(url, API_TIMEOUT)
    .then((response) => {
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'accountingApprover')
    })
}

export const getSchemaSubProjectMainSidebar = () => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })
  const url = `${API_ROOT}/subproject/main-menu`
  return axiosInterceptors
    .get(url, API_TIMEOUT)
    .then((response) => {
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'subProjectMain')
    })
}

export const getAssessmentMenuSidebar = () => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })
  // const url = `http://localhost:9002/api/proposal/assessment/menu`
  const url = `${API_ROOT}/proposal/assessment/menu`
  return axios
    .get(url, API_TIMEOUT)
    .then((response) => {
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'assessmentMenu')
    })
}

export const getSchemaSearchDataSchemaSidebar = () => (dispatch) => {
  dispatch({ type: SIDEBAR.REQUEST })
  // /api/proposal/withdraw-review/menu
  const url = `${API_ROOT}/proposal/proposal-all-detail/menu`
  return axios
    .get(url, API_TIMEOUT)
    .then((response) => {
      // console.log('response ', response)
      dispatch({ type: SIDEBAR.SUCCESS, payload: response.data })
      return response.data
    })
    .catch((error) => {
      return handleError(error, dispatch, 'searchData')
    })
}

export const getSchemaAuditSchemaSidebar = () => (dispatch) => {
  // dispatch({ type: SIDEBAR.REQUEST })

  return getMockData(auditSchema, config.defaultMockDelay, dispatch, {
    type: SIDEBAR.SUCCESS,
  })
}
export const getSchemaEvaluatesSchemaSidebar = () => (dispatch) => {
  // dispatch({ type: SIDEBAR.REQUEST })

  return getMockData(evaluatesSchema, config.defaultMockDelay, dispatch, {
    type: SIDEBAR.SUCCESS,
  })
}

export const getMockSchemaSidebar = (mockSchemaSidebar) => (dispatch) => {
  // dispatch({ type: SIDEBAR.REQUEST })

  return getMockData(mockSchemaSidebar, config.defaultMockDelay, dispatch, {
    type: SIDEBAR.SUCCESS,
  })
}

export const setIsExpandedSidebar = (isExpanded) => (dispatch) => {
  dispatch({ type: SIDEBAR.SET_IS_EXPANDED, payload: isExpanded })
}
